var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _g2, _g3, _path12, _path13, _path14, _path15, _g4, _ellipse, _ellipse2, _ellipse3, _rect, _path16, _path17, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04346 43.2055C8.46711 41.9199 11.2211 40.4241 12.751 39.8542L15.1408 44.0809L21.5283 45.4898C20.7328 45.4898 13.9593 48.6427 11.0269 50.186V45.4412C9.56969 44.394 8.04346 43.2055 8.04346 43.2055Z",
    fill: "#408CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9497 43.2055C44.5261 41.9199 41.7721 40.4241 40.2422 39.8542L37.8524 44.0809L30.9917 45.4898C31.7873 45.4898 39.0339 48.6427 41.9663 50.186V45.4412C43.4235 44.394 44.9497 43.2055 44.9497 43.2055Z",
    fill: "#408CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6898 42.2024L21.5287 45.4898L15.1411 44.0809L18.6898 42.2024Z",
    fill: "#0066FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0678 42.2024L30.9923 45.4898L37.853 44.0809L34.0678 42.2024Z",
    fill: "#0066FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2988 0.875L33.8794 9.68049H18.7181L26.2988 0.875Z",
    fill: "url(#paint0_linear_1565_28626)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2994 51.125L18.7188 42.3195L33.88 42.3195L26.2994 51.125Z",
    fill: "url(#paint1_linear_1565_28626)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1565_28626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0911 3.12866L26.9694 5.77916L29.6398 6.65086L26.9694 7.52256L26.0911 10.1731L25.2129 7.52256L22.5425 6.65086L25.2129 5.77916L26.0911 3.12866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0911 3.20829L26.9456 5.78704L26.9496 5.79904L26.9616 5.80297L29.5591 6.65086L26.9616 7.49875L26.9496 7.50267L26.9456 7.51468L26.0911 10.0934L25.2367 7.51468L25.2327 7.50267L25.2207 7.49875L22.6232 6.65086L25.2207 5.80297L25.2327 5.79904L25.2367 5.78704L26.0911 3.20829Z",
    stroke: "#3E74FF",
    strokeWidth: 0.0500935
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2215 38.5622L36.7481 40.6755L44.3287 27.6434L48.2215 38.5622Z",
    fill: "url(#paint2_linear_1565_28626)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37667 13.4378L15.85 11.3245L8.26942 24.3566L4.37667 13.4378Z",
    fill: "url(#paint3_linear_1565_28626)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2214 13.4372L44.3286 24.356L36.748 11.3239L48.2214 13.4372Z",
    fill: "url(#paint4_linear_1565_28626)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37675 38.5628L8.2695 27.644L15.8501 40.6761L4.37675 38.5628Z",
    fill: "url(#paint5_linear_1565_28626)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8101 25.7652C45.8101 36.3292 37.1817 44.8946 26.536 44.8946C15.8904 44.8946 7.26195 36.3292 7.26195 25.7652C7.26195 15.2012 15.8904 6.63573 26.536 6.63573C37.1817 6.63573 45.8101 15.2012 45.8101 25.7652Z",
    fill: "url(#paint6_linear_1565_28626)",
    stroke: "url(#paint7_linear_1565_28626)",
    strokeWidth: 0.250467
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1565_28626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.536,
    cy: 25.7652,
    rx: 17.0335,
    ry: 16.9065,
    fill: "url(#paint8_linear_1565_28626)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1565_28626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5359,
    cy: 25.7646,
    rx: 14.1946,
    ry: 14.0888,
    fill: "url(#paint9_linear_1565_28626)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1565_28626)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1534 23.359C17.9009 22.6806 18.6595 22.0725 19.2667 22.4666L30.6252 29.8379C31.2528 30.2452 30.9644 31.2196 30.2161 31.2196H21.6016C21.2877 31.2196 21.0069 31.0245 20.8974 30.7303L18.1534 23.359Z",
    fill: "url(#paint10_linear_1565_28626)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9155 23.3499C35.1707 22.6731 34.416 22.062 33.807 22.4522L22.2842 29.8355C21.6522 30.2405 21.939 31.2196 22.6895 31.2196H31.4288C31.7415 31.2196 32.0215 31.0259 32.1319 30.7333L34.9155 23.3499Z",
    fill: "url(#paint11_linear_1565_28626)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8627 20.6493C26.1375 20.0879 26.9377 20.0879 27.2125 20.6493L31.9046 30.2354C32.1489 30.7346 31.7855 31.3171 31.2297 31.3171H21.8456C21.2898 31.3171 20.9263 30.7346 21.1707 30.2354L25.8627 20.6493Z",
    fill: "url(#paint12_linear_1565_28626)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1565_28626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 20,
    width: 11,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8627 20.6506C26.1375 20.0891 26.9377 20.0891 27.2125 20.6506L31.9046 30.2366C32.1489 30.7358 31.7855 31.3183 31.2297 31.3183H21.8456C21.2898 31.3183 20.9263 30.7358 21.1707 30.2366L25.8627 20.6506Z",
    fill: "url(#paint13_linear_1565_28626)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1565_28626)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1565_28626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.17574,
    cy: 1.67601,
    rx: 6.17574,
    ry: 1.67601,
    transform: "matrix(0.204188 0.978932 -0.979534 0.201279 30.3618 20.7839)",
    fill: "#7BB0FF"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5376,
    cy: 18.3898,
    rx: 1.08543,
    ry: 1.07734,
    fill: "url(#paint14_linear_1565_28626)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9603,
    cy: 21.5236,
    rx: 0.88808,
    ry: 0.88146,
    fill: "url(#paint15_linear_1565_28626)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.0697,
    cy: 21.5236,
    rx: 0.88808,
    ry: 0.88146,
    fill: "url(#paint16_linear_1565_28626)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.0356,
    y: 32.1672,
    width: 10.7956,
    height: 1.46116,
    rx: 0.730579,
    fill: "url(#paint17_linear_1565_28626)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9649 13.5549L19.3162 14.6151L20.3843 14.9638L19.3162 15.3125L18.9649 16.3727L18.6136 15.3125L17.5454 14.9638L18.6136 14.6151L18.9649 13.5549Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7066 8.85864L15.5263 11.3324L18.0187 12.146L15.5263 12.9596L14.7066 15.4334L13.8869 12.9596L11.3945 12.146L13.8869 11.3324L14.7066 8.85864Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1565_28626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3555 38.0829L15.1407 44.0809C25.3135 38.6802 35.0131 42.672 37.8521 44.0809L41.6373 38.0829C40.5549 36.8419 36.0189 34.3324 26.5341 34.2221C17.0494 34.1118 12.463 36.75 11.3555 38.0829Z",
    fill: "url(#paint18_linear_1565_28626)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1565_28626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4157 39.1892L21.6879 36.6732V36.6518H20.2164V36.2747H22.1433V36.6646L20.8753 39.1892H20.4157ZM22.8147 39.1892L24.0869 36.6732V36.6518H22.6154V36.2747H24.5423V36.6646L23.2743 39.1892H22.8147ZM26.6667 37.0403C26.6515 36.9056 26.5889 36.8012 26.4788 36.7272C26.3688 36.6523 26.2302 36.6148 26.0633 36.6148C25.9437 36.6148 25.8403 36.6338 25.753 36.6717C25.6657 36.7087 25.5979 36.76 25.5495 36.8254C25.5021 36.8899 25.4784 36.9635 25.4784 37.046C25.4784 37.1153 25.4945 37.175 25.5268 37.2253C25.56 37.2756 25.6031 37.3178 25.6563 37.352C25.7103 37.3852 25.7682 37.4132 25.8299 37.4359C25.8915 37.4578 25.9508 37.4758 26.0078 37.49L26.2924 37.564C26.3854 37.5868 26.4807 37.6176 26.5784 37.6565C26.6762 37.6954 26.7668 37.7467 26.8502 37.8102C26.9337 37.8738 27.0011 37.9525 27.0523 38.0465C27.1045 38.1404 27.1306 38.2528 27.1306 38.3837C27.1306 38.5488 27.0879 38.6954 27.0025 38.8235C26.9181 38.9515 26.7952 39.0526 26.6339 39.1266C26.4736 39.2006 26.2796 39.2376 26.0519 39.2376C25.8337 39.2376 25.6449 39.203 25.4855 39.1337C25.3261 39.0644 25.2013 38.9663 25.1112 38.8391C25.0211 38.711 24.9713 38.5592 24.9618 38.3837H25.4029C25.4115 38.489 25.4456 38.5768 25.5054 38.647C25.5661 38.7163 25.6434 38.768 25.7374 38.8021C25.8322 38.8353 25.9361 38.8519 26.049 38.8519C26.1733 38.8519 26.2838 38.8325 26.3806 38.7936C26.4783 38.7537 26.5552 38.6987 26.6112 38.6285C26.6671 38.5573 26.6951 38.4743 26.6951 38.3795C26.6951 38.2931 26.6705 38.2224 26.6211 38.1674C26.5727 38.1124 26.5068 38.0668 26.4233 38.0308C26.3408 37.9947 26.2473 37.963 26.143 37.9354L25.7986 37.8415C25.5652 37.778 25.3802 37.6845 25.2436 37.5612C25.1079 37.4378 25.0401 37.2747 25.0401 37.0716C25.0401 36.9037 25.0856 36.7571 25.1767 36.6319C25.2677 36.5066 25.3911 36.4094 25.5467 36.3401C25.7023 36.2699 25.8778 36.2348 26.0732 36.2348C26.2706 36.2348 26.4447 36.2695 26.5955 36.3387C26.7473 36.408 26.8668 36.5033 26.9541 36.6248C27.0414 36.7453 27.087 36.8838 27.0908 37.0403H26.6667ZM30.1878 37.7319C30.1878 38.0431 30.1309 38.3107 30.017 38.5346C29.9032 38.7575 29.7471 38.9293 29.5488 39.0497C29.3515 39.1693 29.1271 39.2291 28.8757 39.2291C28.6233 39.2291 28.398 39.1693 28.1997 39.0497C28.0024 38.9293 27.8468 38.7571 27.7329 38.5332C27.6191 38.3093 27.5622 38.0422 27.5622 37.7319C27.5622 37.4208 27.6191 37.1537 27.7329 36.9307C27.8468 36.7068 28.0024 36.5351 28.1997 36.4156C28.398 36.2951 28.6233 36.2348 28.8757 36.2348C29.1271 36.2348 29.3515 36.2951 29.5488 36.4156C29.7471 36.5351 29.9032 36.7068 30.017 36.9307C30.1309 37.1537 30.1878 37.4208 30.1878 37.7319ZM29.7523 37.7319C29.7523 37.4948 29.7139 37.295 29.6371 37.1328C29.5612 36.9696 29.4568 36.8463 29.324 36.7628C29.1921 36.6784 29.0427 36.6362 28.8757 36.6362C28.7078 36.6362 28.5579 36.6784 28.426 36.7628C28.2941 36.8463 28.1897 36.9696 28.1129 37.1328C28.037 37.295 27.9991 37.4948 27.9991 37.7319C27.9991 37.9691 28.037 38.1693 28.1129 38.3325C28.1897 38.4947 28.2941 38.6181 28.426 38.7025C28.5579 38.786 28.7078 38.8277 28.8757 38.8277C29.0427 38.8277 29.1921 38.786 29.324 38.7025C29.4568 38.6181 29.5612 38.4947 29.6371 38.3325C29.7139 38.1693 29.7523 37.9691 29.7523 37.7319ZM30.736 39.1892V36.2747H31.1758V38.8107H32.4964V39.1892H30.736Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1565_28626",
    x: 21.2901,
    y: 1.87633,
    width: 9.60184,
    height: 9.54911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.626168,
    result: "effect1_foregroundBlur_1565_28626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1565_28626",
    x: 9.50244,
    y: 8.35771,
    width: 34.0669,
    height: 34.3139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.500935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.500935
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.172667 0 0 0 0 0.616667 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_28626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1565_28626",
    x: 12.3413,
    y: 11.1748,
    width: 28.3892,
    height: 29.1794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.500935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25234
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.193203 0 0 0 0 0.4875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_28626"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.500935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25234
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4375 0 0 0 0 0.62875 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1565_28626",
    result: "effect2_innerShadow_1565_28626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1565_28626",
    x: 16.0704,
    y: 16.8116,
    width: 20.8895,
    height: 18.3197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.500935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.500935
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.111875 0 0 0 0 0.364131 0 0 0 0 0.745833 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1565_28626",
    x: 26.4083,
    y: 19.609,
    width: 7.14574,
    height: 15.116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.751402,
    result: "effect1_foregroundBlur_1565_28626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1565_28626",
    x: 6.34612,
    y: 31.7141,
    width: 40.3004,
    height: 19.8808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.50467
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.50467
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1565_28626",
    x: 20.2163,
    y: 36.2349,
    width: 12.2803,
    height: 3.25315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.250467
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.221676 0 0 0 0 0.154219 0 0 0 0 0.5875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_28626",
    x1: 23.1475,
    y1: 4.3972,
    x2: 29.45,
    y2: 4.3972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1565_28626",
    x1: 29.4506,
    y1: 47.6028,
    x2: 23.1482,
    y2: 47.6028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1565_28626",
    x1: 46.7239,
    y1: 34.0924,
    x2: 43.6079,
    y2: 39.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1565_28626",
    x1: 5.87429,
    y1: 17.9076,
    x2: 8.99026,
    y2: 12.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1565_28626",
    x1: 43.5726,
    y1: 12.4896,
    x2: 46.6885,
    y2: 17.9272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1565_28626",
    x1: 9.02557,
    y1: 39.5104,
    x2: 5.90961,
    y2: 34.0728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1565_28626",
    x1: 14.1006,
    y1: 11.4476,
    x2: 39.7519,
    y2: 40.2736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1565_28626",
    x1: 26.536,
    y1: 6.5105,
    x2: 26.536,
    y2: 45.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1565_28626",
    x1: 15.6534,
    y1: 12.8505,
    x2: 37.2257,
    y2: 39.0733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1565_28626",
    x1: 17.1424,
    y1: 14.162,
    x2: 28.6875,
    y2: 39.9182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#376EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1352B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1565_28626",
    x1: 18.2944,
    y1: 24.07,
    x2: 24.0257,
    y2: 28.2695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1565_28626",
    x1: 34.1815,
    y1: 22.857,
    x2: 30.7296,
    y2: 29.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1565_28626",
    x1: 23.5211,
    y1: 25.4717,
    x2: 29.6403,
    y2: 25.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49728,
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1565_28626",
    x1: 23.5211,
    y1: 25.4729,
    x2: 29.6403,
    y2: 25.4729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#B1B0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1565_28626",
    x1: 26.5376,
    y1: 17.3125,
    x2: 26.5376,
    y2: 19.4672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1565_28626",
    x1: 17.9603,
    y1: 20.6421,
    x2: 17.9603,
    y2: 22.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1565_28626",
    x1: 35.0697,
    y1: 20.6421,
    x2: 35.0697,
    y2: 22.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1565_28626",
    x1: 21.1583,
    y1: 32.8978,
    x2: 31.954,
    y2: 32.8978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1565_28626",
    x1: 12.9757,
    y1: 39.9203,
    x2: 40.24,
    y2: 39.6165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.9803980b8e76b037016ab5d814c7ada7.svg";
export { ForwardRef as ReactComponent };